<template>
  <div class="pages">
    <van-popup v-model="show" get-container="body" :style="{ height: '85%', width: '96%' }" :closeable="true">
      <div class="">
        <div class="plr20 bggrey ft28" style="height: 6vh; line-height: 6vh">
          列表
        </div>
        <div class="itme-wrapper" v-if="showbottleList.length">
          <div v-for="(item, index) in showbottleList" :key="index"
            style="padding: 0 0 10px; position: relative;background: #e8e8e8;">
            <div class="items">
              <span class="item-name">登记单位：</span>
              <span class="item-value">{{ item.ownerDeptName || '-' }}</span>
            </div>
            <div class="items">
              <span class="item-name">气瓶编号：</span>
              <span class="item-value">{{ item.bottleId || '-' }}</span>
            </div>
            <div class="items">
              <span class="item-name">填充介质：</span>
              <span class="item-value">{{ item.gasTypeName || '-' }}</span>
            </div>
            <div class="items">
              <span class="item-name">入库时间：</span>
              <span class="item-value">{{ item.incomingTime || '-' }}</span>
            </div>

          </div>
        </div>
        <div class="tc ptb10">
          <van-button type="danger" class="tc" @click="show = false">关闭</van-button>
        </div>
      </div>
    </van-popup>
    <van-popup v-model="showSysDept" round position="bottom">
      <van-cascader v-model="cascaderValue" title="请选择归还部门" :options="sysDeptsOptions" @close="showSysDept = false"
        @change="onSysDeptChange" @finish="onSysDeptFinish" />
    </van-popup>
    <div class="top-tab">
      <van-tabs @click="initContent" v-model="active" color="#4597ff">
        <van-tab title="归还申请">
          <div class="page-apply">
            <div class="flex alcenter between">
              <!-- <van-field label-align="center" :readonly="true" v-model="appForm.sysDeptName" @click="openSysDeptPicker()" label="归还部门"
                    placeholder="请选择归还部门" :required="true" :rules="[{ required: true, message: '请选择归还部门' }]" /> -->
              <van-field label-align="center" v-model="appForm.sysDeptName" is-link readonly label="归还部门" placeholder="请选择归还部门"
                @click="getSysDepart" :required="true" :rules="[{ required: true, message: '' }]" />
            </div>
            <div class="flex alcenter between">
              <van-field label-align="center" type="number" label="归还个数" v-model="appForm.returnCount" placeholder="请输入归还个数" :required="true"
              :rules="[{ required: true, message: '' }]" />
            </div>
            <div class="flex alcenter between">
              <van-field label-align="center" type="string" label="备注" v-model="appForm.remark" placeholder="选填"
                :required="false" :rules="[{ required: false, message: '' }]" />
            </div>
            <div class="flex alcenter between">
              <van-field label-align="center" readonly clickable name="picker" :value="appForm.auditerName" label="审核人员"
                placeholder="点击选择审核人员" :required="true" :rules="[{ required: true, message: '请选择审核人员' }]"
                @click="showPicker1 = true" />
              <div class="saoma" @click="scanQRcode">扫码归还</div>
            </div>
          </div>
          <div class="colors">
            <span>归还列表 (已归还：{{ appForm.bottleList.length }},剩余：{{ appForm.returnCount - appForm.bottleList.length }})</span>
          </div>
          <div class="itme-wrapper">
            <div class="" style="
                margin-bottom: 16px;
                padding: 10px 0;
                position: relative;
                background: #e8e8e8;
              " v-for="(item, index) in appForm.bottleList" :key="index">
              <div class="items">
                <span class="item-name">气瓶编号：</span>
                <span class="item-value">{{ item.bottleId }}</span>
              </div>
              <div class="items">
                <span class="item-name">充装介质：</span>
                <span class="item-value">{{ item.gasTypeName }}</span>
              </div>
              <div class="items">
                <span class="item-name">气瓶状态：</span>
                <span class="item-value">{{ item.fullFlag ? '满瓶' : '空瓶' }}</span>
              </div>
              <div class="items">
                <span class="item-name">领用时间：</span>
                <span class="item-value">{{ item.borrowDate }}</span>
              </div>

              <div class="delete-btn">
                <van-button type="danger" size="small" class="btns" @click="deleteItem(index)">删除</van-button>
                <van-button type="info" size="small" class="btns" @click="handleupdate(item)">修改</van-button>
              </div>
            </div>
          </div>
          <div style="position: fixed; bottom: 0" class="flex w100">
            <van-button class="flex1 w47" style="border-right: 3px solid #fff" square block type="info"
              native-type="button" @click="reset">重置</van-button>
            <van-button class="flex1 w50" square block type="info" @click="submitbottle">提交</van-button>
          </div>
        </van-tab>
        <van-tab title="归还历史">
          <van-pull-refresh class="bggrey" v-model="isLoading" @refresh="onRefresh">
            <van-list class="history" v-model="loading" :finished="finishedBottom" finished-text="没有更多了" @load="onLoad">
              <div class="his-wrapper" v-for="(item, index) in historyList" :key="index">
                <div class="history-left">
                  <div class="his-items">
                    <span>归还部门：</span>
                    <span>{{ item.sysDeptName }}</span>
                  </div>
                  <div class="his-items">
                    <span>归还个数：</span>
                    <span>{{ item.returnCount || '-' }}</span>
                  </div>
                  <div class="his-items">
                    <span>归还时间：</span>
                    <span>{{ item.returnTime || '-' }}</span>
                  </div>
                  <div class="his-items">
                    <span>审核人：</span>
                    <span>{{ item.auditerName || '-' }}</span>
                  </div>
                  <div class="his-items">
                    <span>备注：</span>
                    <span>{{ item.remark || '-' }}</span>
                  </div>
                </div>
                <div class="hisotry-right">
                  <img v-if="item.auditStatus == 0" src="@/assets/visitor/daishenhe.png" alt="" /> 
                  <img v-if="item.auditStatus == 1" src="@/assets/visitor/agree.png" alt="" />                        
                  <img v-if="item.auditStatus == 2" src="@/assets/visitor/reject.png"	alt="" />
                </div>
                <van-button plain type="primary" size="small" class="audits" @click="getDetail(item)">列表</van-button>
                <van-button v-if="item.auditStatus == 2" plain type="primary" size="small" class="userBtn1"
											@click="editReturn(item)">编辑</van-button>
              </div>
            </van-list>
          </van-pull-refresh>
        </van-tab>
      </van-tabs>
    </div>
    <!-- 修改状态 -->
    <van-popup v-model="showPicker" position="bottom" round>
      <van-picker item-height="7vh" show-toolbar :columns="columns" @confirm="onConfirm" @cancel="showPicker = false" />
    </van-popup>
    <!-- 审核人 -->
    <van-popup v-model="showPicker1" position="bottom" round>
      <van-picker item-height="7vh" show-toolbar :columns="columns1" @confirm="onConfirm1"
        @cancel="showPicker1 = false" />
    </van-popup>
    <!-- <van-popup v-model="showSysDeptPicker" position="bottom" round>
      <van-picker item-height="7vh" show-toolbar :columns="columnsSysDepts" @confirm="onSysDeptPickerConfirm"
        @cancel="showSysDeptPicker = false" />
    </van-popup> -->

  </div>
</template>

<script>
import {
  getAdmins,//审核人列表
  getConfigInfo,//扫码配置信息
  queryReturnHistory,//历史列表
  addReturnRecord,//添加归还记录
  queryReturnBottle,//通过条码查询要归还的气瓶信息
  queryReturnBottleByQrcode,//通过二维码查询要归还的气瓶信息
  queryReturnDetail,//归还历史记录详情
  getDepartments,//获取部门列表
  //bottleInfoQueryAll,//气瓶登记单位
  //querySysDeptInfo,//归还部门列表
} from "@/apis/api";
import { Dialog, Toast } from "vant";
export default {
  data() {
    return {
      active: 0,
      showPicker: false,
      showPicker1: false,
      // showSysDeptPicker: false,
      sysDeptsOptions: [],//下拉选择的部门
      cascaderValue: "",
      showSysDept: false,
      appForm: {
        sysDept: "", //归还部门id
        sysDeptName: "", //归还部门名称
        auditer: "", // 审核人Id ,
        auditerName: "", // 审核人姓名 ,
        returnCount: "", //气瓶总数 ,
        remark: "", //备注 ,
        bottleList: [],
      },
      showbottleList: [],
      show: false,
      updateItem: {},
      columns: [],
      columns1: [],
      columnsSysDepts: [],
      historyList: [],
      pageSize: 10,
      pageNo: 1,
      total: 0,
      isLoading: false,
      loading: false,
      finishedBottom: false,
    };
  },
  mounted() {
    document.title = "气瓶归还";
    this.getSystemConfig()
    this.getAdmin();
  },
  methods: {
    // tab点击
    initContent(value) {
      this.active = value;
      if (value == 0) {
        // 刷新页面
      } else {
        this.pageSize = 10;
        this.pageNo = 1;
        this.getHistoryList();
      }
    },
    // 获取历史
    getHistoryList() {
      this.onRefresh(1);
    },
    //历史列表
    onRefresh(index) {
      this.pageNo = 1;
      this.pageSize = 10;
      this.isLoading = true;
      queryReturnHistory({
        pageNo: this.pageNo,
        pageSize: this.pageSize,
      }).then((res) => {
        this.isLoading = false;
        this.loading = false;
        if (res.code == 200) {
          if (index != 1) {
            Toast("刷新成功");
          }
          this.historyList = res.result.records;
          this.total = res.result.total;
          if (this.historyList.length == this.total) {
            this.finishedBottom = true;
          }
        } else {
          this.finishedBottom = true;
        }
      });
    },
    // 历史列表加载更多
    onLoad() {
      console.log("加载更多");
      if (this.isLoading) return;
      this.pageNo++;
      queryReturnHistory({
        pageNo: this.pageNo,
        pageSize: this.pageSize,
      }).then((res) => {
        this.isLoading = false;
        this.loading = false;
        if (res.code == 200) {
          this.historyList = this.historyList.concat(res.result.records);
          if (this.historyList.length == this.total) {
            this.finishedBottom = true;
          }
        } else {
          this.finishedBottom = true;
        }
      });
    },
    //历史记录详情
    getDetail(item) {
      this.show = true;
      this.getOutDetailList(item.id)
    },
    getOutDetailList(id) {
      queryReturnDetail({
        applyforId: id
      }).then(res => {
        if (res.code == 200) {
          this.showbottleList = res.result;
        } else {
          this.$toast(res.message);
        }
      })
    },
    //删除气瓶
    deleteItem(index) {
      Dialog.confirm({
        title: "提示",
        message: "确认删除该气瓶吗？",
      }).then(() => {
        if (this.appForm.bottleList.length >= 1) {
          this.appForm.bottleList.splice(index, 1);
        }
      }).catch(() => { });
    },
    // 重置
    reset() {
      this.appForm = {
        sysDept: "", //归还部门id
        sysDeptName: "", //归还部门名称
        auditer: "", // 审核人Id ,
        auditerName: "", // 审核人姓名 ,
        returnCount: "", //气瓶总数 ,
        remark: "", //备注 ,
        bottleList: [],
      }
    },
    // 提交
    submitbottle() {
      if (this.appForm.sysDept == "") {
        this.$toast('请选择归还部门');
        return;
      }
      if (this.appForm.auditer == "") {
        this.$toast('请选择审核人员');
        return;
      }
      if (this.appForm.bottleList.length <this.appForm.returnCount) {
        this.$toast('请扫码添加气瓶');        
      } else {
        this.appForm.returnCount = this.appForm.bottleList.length;
        addReturnRecord(this.appForm).then((res) => {
          if (res.code == 200) {
            this.$toast(res.message || '提交成功');
            this.reset();
          } else {
            this.$toast(res.message || '提交失败');
          }
        });
      }
    },
    //扫码配置项目
    getSystemConfig() {
      getConfigInfo({
        curUrl: encodeURI(location.href.split('#')[0])
      }).then(res => {
        if (res.code == 200) {
          let configs = res.result
          wx.config({
            debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
            appId: configs.appId, // 必填，公众号的唯一标识
            timestamp: configs.timestamp, // 必填，生成签名的时间戳
            nonceStr: configs.nonceStr, // 必填，生成签名的随机串
            signature: configs.signature,// 必填，签名
            jsApiList: ['scanQRCode'] // 必填，需要使用的JS接口列表
          });
          wx.ready((res) => {
            console.log('配置完成，扫码前准备完成')
          })
          wx.error(function (res) {
            console.log('出错了：' + res.errMsg);
          });
        } else {
          this.$toast(res.message);
        }
      }).catch(err => { })
    },
    //扫码
    scanQRcode() {
      if(this.appForm.returnCount<= 0)
      {
        this.$toast("请先设置归还数量");
        return
      }
      if(this.appForm.bottleList.length == this.appForm.returnCount)   //入库数量等于气瓶总数
      {
        this.$toast("当前归还数量已达到最大值，请提交");
        return
      }
      var ua = navigator.userAgent.toLowerCase()
      var isWeixin = ua.indexOf('micromessenger') !== -1
      if (!isWeixin) {
        alert('请用微信打开连接，才可使用扫一扫')
      }
      wx.scanQRCode({
        needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
        //scanType: ["barCode"], // 条形码
        scanType: ["qrCode",], // 二维码
        success: (res) => {
          console.log(res);
          //条码
          //this.getGasDetail(res.resultStr.split(',')[1] || res.resultStr)
          //二维码
          this.getGasDetail(res.resultStr)
        },
        fail: (err) => {
          console.log(err);
        }
      });
    },
    //获取气瓶信息
    getGasDetail(resultStr) {
      //queryReturnBottle
      queryReturnBottleByQrcode({
       // bottleNo: resultStr
       qrcode: resultStr
      }).then(res => {
        if (res.code == 200) {
          res.result.fullFlag = 0;
          //判断当前气瓶是否在列表中       
          for (let i = 0; i < this.appForm.bottleList.length; i++) {
            if (this.appForm.bottleList[i].bottleId === res.result.bottleId) {
              this.$toast(`该气瓶已存在，请勿重复添加`);
              return;
            }
          }
          this.appForm.bottleList.splice(0, 0, res.result);
          this.$set(this.appForm.bottleList, this.appForm.bottleList);
          if(this.appForm.bottleList.length == this.appForm.returnCount)   //入库数量等于气瓶总数
          {
            this.$toast("当前归还数量已达到最大值，请提交");            
          }
        } else {
          this.$toast(res.message);
        }
      })
    },
    // 修改满瓶空瓶确认
    onConfirm(e) {
      this.updateItem.fullFlag = e.id;
      this.showPicker = false;
    },
    // 满瓶空瓶弹窗打开
    handleupdate(item) {
      this.updateItem = item;
      this.showPicker = true;
      this.columns = [
        { id: 1, text: '满瓶', },
        { id: 0, text: '空瓶', }
      ]
    },
    // 审核人确认按钮
    onConfirm1(e) {
      this.appForm.auditer = e.id;
      this.appForm.auditerName = e.text;
      this.showPicker1 = false;
    },
    //查询审核人弹窗列表
    getAdmin() {
      this.columns1 = []
      getAdmins().then((res) => {
        if (res.code == 200) {
          if (res.result.length) {
            res.result.forEach((i, v) => {
              i.id = i.uid;
              i.text = i.personName;
            });
          }
          this.columns1 = res.result;
        } else {
          this.$toast(res.message);
        }
      });
    },

    getSysDepart() {
      this.showSysDept = true;
      getDepartments().then((res) => {
        console.log(res);
        this.sysDeptsOptions = res.result.map((item) => {
          item.text = item.departName;
          item.value = item.id;
          if (item.departList.length > 0) {
            item.children = item.departList;
            item.children.forEach(iitem => {
              iitem.text = iitem.departName
              iitem.value = iitem.id;
            })
          }

          return item;
        });
      });
    },

    onSysDeptChange({
      value
    }) {

    },
    onSysDeptFinish({
      selectedOptions
    }) {
      this.showSysDept = false;
      this.appForm.sysDeptName = selectedOptions.map((option) => option.text).join("/");
      this.appForm.sysDept = selectedOptions.pop().value;
      console.info("选择的部门：" + this.appForm.sysDeptName + ",部门id:" + this.appForm.sysDept);
    },
    //编辑归还记录
    editReturn(item){      
      this.appForm.sysDept = item.sysDept;
      this.appForm.sysDeptName = item.sysDeptName;
      this.appForm.auditer = item.auditer;
      this.appForm.auditerName = item.auditerName;
      this.appForm.returnCount = item.returnCount;
      this.appForm.remark = item.remark;
      //要把之前提交的id清空     
      this.appForm.bottleList = [];
      queryReturnDetail({
        applyforId: item.id
      }).then(res => {
        if (res.code == 200) {
          this.appForm.bottleList = res.result.filter((item) => {
            return item.stockStatus == 2;//只取当前领用的状态
          }); 
        } else {
          this.$toast(res.message);
        }
      });
      this.active = 0;
      
    },
  },
};
</script>

<style lang="less" scoped>
.pages {
  background: #f3f3f3;
  min-height: 100vh;
}

.colors {
  color: #e80404;
  margin: 14px 0 0 40px;
}

.history {
  padding: 16px;
  min-height: 90vh;
  border-radius: 6px;

  .his-wrapper {
    background: #fff;
    border-radius: 6px;
    padding: 15px;
    position: relative;
    margin-bottom: 18px;
    display: flex;
    justify-content: space-between;
    align-items: flex-end;

    .hisotry-right {
      img {
        width: 150px;
        height: 150px;
      }
    }

    .history-left {
      .his-items {
        height: 50px;
        line-height: 50px;

        span {
          font-size: 28px;
          color: #333;
        }
      }
    }

    .audits {
      position: absolute;
      right: 20px;
      top: 25px;
      width: 94px;
      height: 40px;
      text-align: center;
      line-height: 40px;
      background: none;
      border-radius: 5px;
      color: #55aa7f;
    }

    .userBtn1 {
      position: absolute;
      right: 20px;
      top: 90px;
      width: 94px;
      height: 40px;
      text-align: center;
      line-height: 40px;
      background: none;
      border-radius: 5px;
      color: #55aa7f; 
    }
  }
}

.delete-btn {
  position: absolute;
  right: 20px;
  top: 20px;
  display: flex;
  flex-direction: column;

  .btns {
    height: 40px;
    margin-bottom: 20px;
  }
}

.itme-wrapper {
  padding: 16px;

  // background: #e8e8e8;
  .items {
    height: 50px;
    padding: 0 10px;
    line-height: 50px;
  }
}


.page-apply {
  .saoma {
    width: 20vw;
    background-color: #4597ff;
    color: #fff;
    height: 6.5vh;
    line-height: 6.5vh;
    text-align: center;
  }
}
</style>
